<!-- 组包出仓 -->
<template>
  <div class="warehouseOut">
    <div class="warehouseOut-main">
      <div class="div-table-row table-title">
        <div class="div-table-cell" style="width: 15%">配件名称</div>
        <div class="div-table-cell" style="width: 15%">配件编码</div>
        <div class="div-table-cell" style="width: 10%">出仓数</div>
        <div class="div-table-cell flex" style="width: 60%">
          <div class="border-right cell-item" style="width: 30%">仓库</div>
          <div class="border-right cell-item" style="width: 30%">仓位</div>
          <div class="border-right cell-item" style="width: 20%">数量</div>
          <div class="cell-item" style="width: 20%"></div>
        </div>
      </div>
      <div class="table-main">
        <div
          class="div-table-row"
          v-for="(item, index) in goodsList"
          :key="item.EntpTempGoodsId"
        >
          <div class="div-table-cell" style="width: 15%">
            {{ item.GoodName }}
          </div>
          <div class="div-table-cell" style="width: 15%">
            {{ item.APCode }}
          </div>
          <div class="div-table-cell" style="width: 10%">
            {{ item.Count * OpCount }}
          </div>
          <div class="div-table-cell" style="width: 60%">
            <div
              class="cell-line"
              v-for="(warehouse, i) in item.GoodsLocationList"
              :key="i.key"
            >
              <div class="border-right cell-item" style="width: 30%">
                <el-select
                  v-model="warehouse.WarehouseId"
                  size="small"
                  :loading="loading"
                  filterable
                  clearable
                  reserve-keyword                
                  @visible-change="
                  wHVisibleChange($event,item)"
                  @change="warehouseChange($event, index, i)"
                  no-data-text="无存放仓库"
                >
                  <el-option
                    v-for="optionItem in item.WarehouseList"
                    :label="optionItem.WarehouseName"
                    :value="optionItem.WarehouseId"
                    v-bind:key="optionItem.index"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="border-right cell-item" style="width: 30%">
                <el-select
                  v-model="warehouse.ShelfSpaceId"
                  :loading="loading"
                  filterable
                  clearable
                  reserve-keyword
                  remote
                  :remote-method="
                        (val) =>
                        remoteMethod(val, warehouse.WarehouseId, warehouse,item.EntpTempGoodsId)
                    "                  
                  @change="positionChange($event,index,i)"
                  @visible-change="
                  positionVisibleChange(
                  $event,
                  warehouse.WarehouseId,
                  warehouse,
                  item.EntpTempGoodsId
                  )"
                  no-data-text="无存放仓位"
                  no-match-text="无存放仓位"                  
                  size="small"
                >
                  <el-option
                    v-for="optionItem in warehouse.ShelfSpacesList"
                    :label="optionItem.ShelfSpaceCode"
                    :value="optionItem.ShelfSpaceId"
                    v-bind:key="optionItem.index"
                  >
                    <span style="display: inline-block; width: 150px">{{
                      optionItem.ShelfSpaceCode
                    }}</span>
                    <span>库存:{{ optionItem.Count }}</span>
                  </el-option>
                </el-select>
              </div>
              <div class="border-right cell-item" style="width: 20%">
                <el-input
                  size="small"
                  type="number"
                  v-model="warehouse.Count"
                  @blur="checkCount(warehouse.Count, warehouse.CountMax)"
                  :max="warehouse.CountMax"
                >
                </el-input>
              </div>
              <div
                class="cell-item ops-ctn"
                style="width: 20%; height: 28px; margin-top: 7px"
              >
                <el-button
                  size="mini"
                  icon="el-icon-minus"
                  @click="delItem(index, i)"
                ></el-button>
              </div>
            </div>
          </div>
          <el-button
            size="mini"
            icon="el-icon-plus"
            class="add-btn"
            @click="addItem(index)"
          ></el-button>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button size="small" @click="cancel" :disabled="dailogLoading">取消</el-button>
      <el-button class="btn-primary" size="small" :disabled="dailogLoading" @click="submitData"
        >提交组包</el-button
      >
    </div>
    <!--    快速存放商品    -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="快速存放商品"
      :visible.sync="storeVisible"
      width="1000px"
      append-to-body
      :before-close="closeStoreDialog"
    >
      <div v-if="storeVisible">
        <storeInventoryGoods
          :autopartItem="enterprisePartData"
          :StoreType="23"
          @closeDialog="closeStoreDialog"
        ></storeInventoryGoods>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import storeInventoryGoods from "@/components/business/goods/storeInventoryGoods.vue";
export default {
  name: "",
  props: ["APList", "SetId", "OpCount"],
  components: { storeInventoryGoods },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      dailogLoading:true,
      loading: false,
      WarehouseList: [],
      PositionList: [],          
      storeVisible: false,
      formData: {
        SetId: this.SetId,
        UserId: userMsg.EmployeeId,
        EntpId: userMsg.EntpId,
        OpCount: this.OpCount,
        GoodsList: [
          {
            EntpTempGoodsId: "",
            GoodsLocationList: [
              {
                ShelfSpaceId: "",
                Count: "",
              },
            ],
          },
        ],
      },
      goodsList: [],
      enterprisePartData: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init(){
     let that = this;
     //仓位对象
     let spaceItem = {
      WarehouseId: "",
      ShelfSpaceCode: "",
      ShelfSpaceId: "",
      Count: "",
      CountMax: 999,
      ShelfSpacesList: [],
    };
    let _APList = [];
    for (let i = 0; i < that.APList.length; i++) {
      spaceItem.Count = that.APList[i].Count;
      _APList.push({
          EntpTempGoodsId:that.APList[i].EntpTempGoodsId,
          GoodName:that.APList[i].GoodName,
          APCode:that.APList[i].APCode,
          Count:that.APList[i].Count,
          WarehouseList: [],
          GoodsLocationList:[{...spaceItem}]
      });
    }
    that.goodsList = _APList;
    that.dailogLoading=false;
    },   
    checkCount(count, max) {
      if (count > max) {
        this.$util.warningMsg("数量不得大于库存数量");
      }
    },
    cancel() {
      this.$emit("closeDialog");
    },
    submitData() {
      let that = this;
      let _data = that.goodsList;
      
      for (let i = 0; i < _data.length; i++) {
        let PV = _data[i].Count;
        let EV = 0;
        for (let j = 0; j < _data[i].GoodsLocationList.length; j++) {
          if (!_data[i].GoodsLocationList[j].ShelfSpaceId) {
            that.$util.warningMsg("请选择仓位");
            return;
          }
          let outCount=Number(_data[i].GoodsLocationList[j].Count);
          if (outCount<= 0) {
            this.$util.warningMsg("出库数量必须大于零");
            return;
          }
          if (outCount >_data[i].GoodsLocationList[j].CountMax) {
            that.$util.warningMsg("数量不得大于库存数量");
            return;
          }
          EV += outCount;
        }
        if (PV * that.OpCount != EV) {
          that.$util.warningMsg("出库数量与列表填写不相等");
          return;
        }
      }
      that.formData.GoodsList = that.goodsList;
      that.dailogLoading=true;
      that.$util
        .axiosPost({
          url: "/api/EntpGoods/ComboEnterpriseGoodsSets",
          data: that.formData,
          hideLoading:true,
        })
        .then((res) => {
          that.dailogLoading=false;
          if (res.errcode == 0) {
            that
              .$confirm("组包成功！但并未存放，是否去存放货物？", "温馨提示", {
                confirmButtonText: "存放货物",
                cancelButtonText: "取消",
                type: "success",
                center: true,
              })
              .then(() => {
                that.enterprisePartData = res.data;
                that.showStoreDialog();
              })
              .catch(() => {
                that.$util.successMsg(res.errmsg);
                that.$store.commit("updateNeedRefresh", true);
                that.$emit("closeDialog",true);
              });
          } else that.$util.errorMsg(res.errmsg);
        }).catch(()=>{that.dailogLoading=false;});
    },
    //仓位下拉框出现/隐藏时触发
    positionVisibleChange(val, warehouseId, warehouse,goodsId) {
      if (!val || !warehouseId) return;
      let that = this;
      if (
        !(warehouse.ShelfSpacesList && warehouse.ShelfSpacesList.length > 0)
      ) {
        that.searchPosition("", warehouseId,goodsId).then(() => {
          that.$set(warehouse, "ShelfSpacesList", [...that.PositionList]);
        });
      }
    },
    remoteMethod(val, warehouseId, warehouse,goodsId) {
      if (!val || !warehouseId) return;
      let that = this;
      that.searchPosition(val, warehouseId,goodsId).then(() => {
        that.$set(warehouse, "ShelfSpacesList", [...that.PositionList]);
      });
    },
    // 搜仓位
    searchPosition(key, warehouseId,goodsId) {
      let that = this;
      if (!warehouseId || that.loading) return;
      that.loading = true;
      return that.$util
        .axiosGet({
          url: "/api/EntpShelfSpaces/GetShelfSpacesListByForSet",
          data: {
            WarehouseId: warehouseId,
            ShelfSpaceCode:key,
            GoodsId: goodsId,
            Limit: 20,
          },
          hideLoading: true,
        })
        .then((res) => {
          that.loading = false;
          if(res.data&& res.data.length > 0)
             that.PositionList = res.data;
          else{
             that.PositionList=[];
             that.$util.warningMsg("无存放仓位");
          }
        })
        .catch((error) => {
          that.loading = false;
        });
    },           
    positionChange(value, index, i) {
      let flag = 0;
      let _data = { ...this.goodsList[index] };
      let target = _data.GoodsLocationList[i].ShelfSpacesList
        ? _data.GoodsLocationList[i].ShelfSpacesList
        : [];
      for (let j = 0; j < _data.GoodsLocationList.length; j++) {
        if (_data.GoodsLocationList[j].ShelfSpaceId == value) {
          flag += 1;
          if (flag >= 2) {
            _data.GoodsLocationList[j].ShelfSpaceId = "";
            this.$util.warningMsg("不能选相同仓位");
            return;
          }
        }
      }
      for (let n = 0; n < target.length; n++) {
        if (target[n].ShelfSpaceId == value) {
          _data.GoodsLocationList[i].CountMax = target[n].Count;
        }
      }
      this.$set(this.goodsList, index, _data);
    },
    //仓库下拉框出现/隐藏时触发
    wHVisibleChange(val, goods) {
      if (!val) return;
      let that = this;
      if (
        !(goods.WarehouseList && goods.WarehouseList.length > 0)
      ) {
        that.searchWarehouse("", goods.EntpTempGoodsId).then(() => {
          that.$set(goods, "WarehouseList", [...that.WarehouseList]);
        });
      }
    },
    searchWarehouse(key,goodsId) {
      let that = this;
      if (!goodsId || that.loading) return;
      that.loading = true;
      return that.$util
        .axiosGet({
          url: "/api/EntpWarehouse/GetWarehouseListForSet",
          data: {
            GoodsId: goodsId,
          },
          hideLoading: true,
        })
        .then((res) => {
          that.loading = false;
          if(res.data&& res.data.length > 0)
             that.WarehouseList = res.data;
          else{
             that.WarehouseList=[];
             that.$util.warningMsg("无存放仓库");
          }
        })
        .catch((error) => {
          that.loading = false;
        });
    },      
    warehouseChange(value, index, i) {
      let _data = { ...this.goodsList[index] }; 
      _data.GoodsLocationList[i].ShelfSpacesList = [];
      _data.GoodsLocationList[i].ShelfSpaceId = "";
      this.$set(this.goodsList, index, _data);
    },
    delItem(index, i) {
      let _data = { ...this.goodsList[index] };
      if (_data.GoodsLocationList.length != 1) {
        _data.GoodsLocationList.splice(i, 1);
      }
      this.$set(this.goodsList, index, _data);
    },
    addItem(index) {
      let _target = this.goodsList[index].GoodsLocationList;
      let usedCount=0;//已选数量
      for (let i = 0; i < _target.length; i++) {
        if (!_target[i].ShelfSpaceId) {
          this.$util.warningMsg("请选择仓位");
          return;
        }
        if (!_target[i].Count || !_target[i].Count < 0) {
          this.$util.warningMsg("请填写正确的数量");
          return;
        }
        usedCount+=Number(_target[i].Count);        
      }
      let goods = { ...this.goodsList[index] };
      //剩余数量
      let surplus=Number(goods.Count)-usedCount  
      goods.GoodsLocationList.push({
        WarehouseId: "",
        ShelfSpaceCode: "",
        ShelfSpaceId: "",
        Count: surplus>0?surplus:0,
        ShelfSpacesList: [],
      });
      this.$set(this.goodsList, index, goods);
    },
    showStoreDialog() {
      this.storeVisible = true;
    },
    closeStoreDialog() {
      this.storeVisible = false;
      this.$emit("closeDialog",true);
      // // 关闭弹窗
      // setTimeout(() => {
      //   this.needConfirm = false;
      //   this.$store.commit("updateNeedRefresh", true);
      //   window.history.go(-1);
      // }, 2000);
    },
  },
};
</script>
<style lang="less" scoped>
.add-btn {
  position: absolute;
  right: 10px;
  bottom: 6px;
}
.ops-ctn {
  text-align: left !important;
}
.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
.warehouseOut-main {
  padding-top: 20px;
}
.table-title {
  .cell-item {
    width: 33.33%;
  }
  .div-table-cell {
    text-align: center;
    height: 30px;
    line-height: 30px;
  }
}
.div-table-row {
  position: relative;
  overflow: visible;
}
.table-main {
  .div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .cell-line {
    display: flex;
    width: 100%;
  }
  .cell-item {
    padding: 0 10px;
    width: 33%;
    width: inherit;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
}
</style>
